module.exports = __webpack_public_path__ + "img/24.a3c5bcd7.png";